<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ?'空运服务':'Air Freight Service'}}</div>
			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				{{$store.state.navShow == true ?'国际空运快线小包运输方案':'International Air Freight Express Small Package Transportation Solution'}}</div>
		</Header>

		<div class="TopTitle" data-aos="fade-up">
			<div class="">
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<div class="ContentText" data-aos="fade-down">
			<p>{{$store.state.navShow == true ? 'MG集团为客户提供石家庄—莫斯科航空包机服务，以最快速的货运周转方案和最低的费率，满足中小货运的物流需求。' : 'MG Group provides Shijiazhuang-Moscow air charter service for customers, and meets the logistics needs of small and medium-sized freight with the fastest freight turnover plan and the lowest rate.'}}
			</p>
		</div>
		<!-- 其他国际铁运路线  -->
		<div class="ConTable">
			<p class="tableTitleTitle1">{{$store.state.navShow == true ? '航空专线' : 'Airline'}}</p>
			<div class="lineDiv" data-aos="fade-up">
				<p class="firstP">{{$store.state.navShow == true ? '(石家庄) 正定' : '(Shijiazhuang) Zhengding'}}</p>
				<p class="zhi">{{$store.state.navShow == true ? '至':'to'}}</p>
				<p class="thirdP">{{$store.state.navShow == true ?'莫斯科/比什凯克':'Moscow/Bishkek'}}</p>
			</div>
		</div>
		<div class="ContenImg_AS">
			<img class="ContenBackgroundImg" :src="imgList.aircraft">

			<div class="technologicalProcess">

				<div class="technologicalProcessCon" :style=" $store.state.navShow == true ? '': 'width: 65%;'" v-for="(item,index) in $store.state.navShow == true ? technologicalProcessList :technologicalProcessListE" :key="index">
					<img class="technologicalProcessimg"
						:src="item.img">
					<div class="technologicalProcessText">
						{{ item.content }}
					</div>
				</div>

			</div>
			<div class="buttonImgAS">
				<!-- <img :src="imgList.bottonImg"> -->
				<img src="../../../assets/OverseasWarehouse/currency.png">
			</div>
		</div>


	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {
				imgList: {
					bannerImg: require('@/assets/chinaAndRussia/CR_airServicesbanner.jpg'),
					// backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
					aircraft: require('@/assets/chinaAndRussia/aircraft.png'),
					// bottonImg: require('@/'),
				},
				technologicalProcessList: [{
						id: 1,
						img: require('@/assets/chinaAndRussia/technologicalProcess_1.png'),
						content: '国际航空包机物流解决方案提供商',
					},
					{
						id: 2,
						img: require('@/assets/chinaAndRussia/technologicalProcess_2.png'),
						content: '专业海外团队满足一站式服务需求',
					},
					{
						id: 3,
						img: require('@/assets/chinaAndRussia/technologicalProcess_3.png'),
						content: '专线小包业务高效配送各类型快件',
					},
				],
					technologicalProcessListE: [{
						id: 1,
						img: require('@/assets/chinaAndRussia/technologicalProcess_1.png'),
						content: 'International air charter logistics solution provider',
					},
					{
						id: 2,
						img: require('@/assets/chinaAndRussia/technologicalProcess_2.png'),
						content: 'Professional overseas team to meet one-stop service needs.',
					},
					{
						id: 3,
						img: require('@/assets/chinaAndRussia/technologicalProcess_3.png'),
						content: 'Dedicated line small package business efficiently distributes various types of express',
					},
				],
			}
		},
		methods: {


		}
	}
</script>

<style lang="less">
	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(
270deg,rgba(3,0,0,.15),hsla(0,0%,100%,.15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}

	.ConTable {
		width: 92%;
		margin: 0 4%;
	}

	.lineDiv {
		width: 100%;
		height: 2.5rem;
		// background: pink;
		display: flex;
		font-size: 0.725rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		text-align: left;
		padding: 5px 0px;
		&>p {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 5px 5px;
		}

		.firstP {
			width: 7.5rem;
			// height: 100%;
			// background: #f8f8f8;
			background-color: #eaf0f7;

		}

		.zhi {
			width: 1.5625rem;
			// background: #f8f8f8;
			margin: 0 0.15625rem;
			background-color: #eaf0f7;
		}

		.thirdP {
			width: calc(100% - 120px - 25px);
			// background: #f8f8f8;
			background-color: #eaf0f7;
		}
	}

	.ContenImg_AS {
		width: 100%;
		height: 15.5625rem;
		position: relative;

		.ContenBackgroundImg {
			position: absolute;
			bottom: 15px;
			right: 0;
			width: 65%;
			height: 13rem;
			z-index: 2;
		}

		.technologicalProcess {
			position: absolute;
			top: 0;
			left: 0;

			.technologicalProcessCon {
				display: flex;
				justify-content: center;
				align-items: center;
				margin: 2rem 0;
				margin-left: 1.03125rem;
		
				.technologicalProcessimg {
					width: 1.009375rem;
					height: 0.9375rem;
				}

				.technologicalProcessText {
					font-size: 0.75rem;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #2E67B1;
					margin-left: 0.8125rem;
					text-align: left;
				}

			}

		}

	}





	.tableTitleTitle1 {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 0.95rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: .2875rem;
	}


	.buttonImgAS {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 2.9375rem;
		z-index: 1;
	}
</style>
